var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 11.666V14.9993M13.334 9.99935V14.9993M10.0007 6.66602V14.9993M16.6673 5.66602V14.3327C16.6673 15.7328 16.6673 16.4329 16.3948 16.9677C16.1552 17.4381 15.7727 17.8205 15.3023 18.0602C14.7675 18.3327 14.0674 18.3327 12.6673 18.3327H7.33398C5.93385 18.3327 5.23379 18.3327 4.69901 18.0602C4.2286 17.8205 3.84615 17.4381 3.60647 16.9677C3.33398 16.4329 3.33398 15.7328 3.33398 14.3327V5.66602C3.33398 4.26588 3.33398 3.56582 3.60647 3.03104C3.84615 2.56063 4.2286 2.17818 4.69901 1.9385C5.23379 1.66602 5.93385 1.66602 7.33398 1.66602H12.6673C14.0674 1.66602 14.7675 1.66602 15.3023 1.9385C15.7727 2.17818 16.1552 2.56063 16.3948 3.03104C16.6673 3.56582 16.6673 4.26588 16.6673 5.66602Z",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutures);
export default __webpack_public_path__ + "static/media/futures.832b4e3d0f1d2a580db11c51b3a3ff47.svg";
export { ForwardRef as ReactComponent };